import IAM from "@/services/api/IAM"
import {TokenStorage} from "@/services/TokenStorage";
import router from "@/router";
import Accounts from "../../services/api/Accounts";
import { authService } from "@/services/authService";

const IAMData = JSON.parse(localStorage.getItem("iam_data"));
const state = {
  keycloak: {
    access_token: IAMData?.access_token || "",
    expires_in: IAMData?.expires_in || "",
    refresh_token: IAMData?.refresh_token || "",
  },

}

const getters = {
  isAuthenticated(state) {
    return !!state.keycloak.access_token;
  },
  getExpiresIn(state) {
    return state.keycloak.expires_in;
  },
  getRefreshToken(state) {
    return state.keycloak.refresh_token;
  }

}

const actions = {
  //eslint-disable-next-line
  loginUser({}, data) {
    return new Promise((resolve, reject) => {
      const {email_address, password} = data
      console.log(data)
      IAM.loginUser(email_address, password).then(response => {
        console.log(response)
        TokenStorage.storeIAMData(response.data);
        resolve(response.data);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  logoutUser({dispatch}, data) {
    Accounts.logout(data).then(() => {
      // authService.logout() clears the Guards token alongside iam_data and sets
      // the sessionStorage flag that stops the bootstrap from silently signing
      // the user straight back in.
      authService.logout();
      dispatch('accounts/toggleAccountModal', null, {root: true});
      return router.replace('/login');
    }).catch(err => {
      console.log(err);
      // Even if the API call fails, still log out locally.
      authService.logout();
      dispatch('accounts/toggleAccountModal', null, {root: true});
      return router.replace('/login');
    });
  },
  //eslint-disable-next-line
  fetchSpaceName({commit}, data) {
    return new Promise((resolve, reject) => {
      const {uuid, token} = data
      IAM.fetchSpaceName(uuid, token).then(response => {
        resolve(response.data);
      }).catch(err => {
        reject(err.response.data);
      });
    })
  },
  //eslint-disable-next-line
  fetchDisplayName({commit}, data) {
    return new Promise((resolve, reject) => {
      const {uuid, token} = data
      IAM.fetchSpaceName(uuid, token).then(response => {
        resolve(response.data);
      }).catch(err => {
        console.log(err);
        reject(err.response);
      });
    })
  },
  //eslint-disable-next-line
  handleSpaceJoin({commit}, data) {
    return new Promise((resolve, reject) => {
      const {uuid, token, action} = data
      IAM.spaceJoin(uuid, {token, action}).then(response => {
        resolve(response.data);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  //eslint-disable-next-line
  register({commit}, payload) {
    return new Promise((resolve, reject) => {
      const {uuid, token, password} = payload;
      IAM.register(uuid, {token, password}).then(response => {
        resolve(response.data);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
